import React, { Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar, faEnvelope } from '@fortawesome/free-regular-svg-icons';
import { NavLink } from 'react-router-dom';
import positions from '../../../assets/images/positions.json';
import { useTranslation } from "react-i18next";

const Research = () =>{

    const { t } = useTranslation();

    function ListPositions(props){
        let  positions = props.positions;
        let listItems = (
            <div className="w-full my-3 flex items-center">
                <div className="flex items-center flex-wrap mx-auto my-32 lg:my-0 p-3">
                    <div className="w-full bg-gray-50 rounded-lg lg:rounded-l-lg border-2 opacity-75 mx-6 lg:mx-0" Style="border-color: #083F5B;">
                        <p className="text-justify p-6 text-base font-bold flex items-center justify-center lg:justify-start">{t("offers.research.empty")}</p>
                    </div>
                </div>
                
            </div>
        );

        positions = positions.filter(pos => pos.category === "research");
        if(positions.length > 0){
            listItems = positions.map((position) => 
                <div className="w-full my-3 flex items-center lg:w-1/2 " key={position.id}>
                    <div className="flex items-center flex-wrap mx-auto p-3">
                        <div className="w-full bg-gray-50 rounded-lg border-2 opacity-75 mx-6 h-auto lg:rounded-l-lg lg:mx-0" Style="border-color: #083F5B;">
                            <div className="px-12 py-4 text-center grid grid-cols-3 lg:text-left">
                                <div className="col-span-3">
                                    <NavLink to={"/doctorados/vacant/"+position.id}>
                                        <h2 className="text-2xl font-bold pt-4 lg:pt-0">{t("position.title."+position.id)}</h2>
                                    </NavLink>
                                    <div className="mx-auto w-full pt-3 border-b-2 lg:mx-0" Style="border-color: #083F5B;"></div>
                                    <p className="text-justify pt-6 text-base font-bold flex items-center justify-center lg:justify-start"><FontAwesomeIcon icon={faCalendar} className="pr-4" Style="color: #083F5B;" />{t("position.aplication_date."+position.id)}</p>
                                    <p className="text-justify pt-2 text-gray-600 text-xs flex items-center justify-center lg:justify-start lg:text-sm"><FontAwesomeIcon icon={faEnvelope} className="pr-4" Style="color: #083F5B;" />{t("position.contact."+position.id)}</p>
                                </div>

                                <div className="col-span-3 text-justify">
                                    <p className="pt-4 text-sm" dangerouslySetInnerHTML={{__html: t("position.description."+position.id) }}></p>
                                </div>
                                <div className="col-end-4 col-span-1 flex justify-end pt-3">
                                    <NavLink to={"/doctorados/vacant/"+position.id} className="text-center group relative w-full py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white" Style="background-color: #083F5B">
                                        More info
                                    </NavLink>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        return (
            <Fragment>{listItems}</Fragment>
        );
    }

    return(
        <Fragment>
            <section className="max-w-7xl mx-auto flex flex-row justify-around flex-wrap">
                
                <ListPositions positions={positions}></ListPositions>
                
            </section>
        </Fragment>
    )
}

export default Research;